//时间戳转时间
const timestampToTime = (timestamp) => {
	if(!timestamp) return ""
	var date = new Date(timestamp + 8 * 3600 * 1000); // 增加8小时
	return date.toJSON().substr(0, 19).replace('T', ' ');
}

// 国际标准格式（2025-03-15T09:42:41.000+00:00）转时间格式
const utcToTime = (t) => {
	return t.substr(0, 19).replace('T', ' ');
}



export default {
	timestampToTime,
	utcToTime
}